import { useLOAReimbursementContext } from "../../Contexts/LOAReimbursementContext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useAuth } from "../../Contexts/AuthContext";
import AlertModal from "./AlertModal";
import KycModal from "./KycModal";
import { useState } from "react";

const LOAReimbursement = () => {
  const { handleBack, navigate } = useLOAReimbursementContext();
  const [alertModalShown, setAlertModalShown] = useState(false);
  const [modalShown, setModalShown] = useState(false);
  const [path, setPath] = useState("");

  const { memberStatus } = useAuth();

  const handleReimbursementRequest = () => {
    if (!memberStatus.isKycVerified) {
      setModalShown(true);
    } else {
      navigate("/loa-reimbursement-services/reimbursement-request");
    }
  };

  const handleCloseModal = () => {
    setModalShown(false);
  };

  const handleShowAlert = (p) => {
    setPath(p);
    setAlertModalShown(true);
  };

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row items-center p-3 border-b">
            <button onClick={handleBack}>
              <KeyboardArrowLeftIcon />
            </button>
            <div className="text-center text-md font-bold flex-1">
              For other hospitals or providers
            </div>
            <button disabled>
              <KeyboardArrowLeftIcon className="invisible" />
            </button>
          </div>

          <div className="p-4">
            <div className="text-[#1F2328] text-xl font-bold mb-1">
              LOA and Reimbursements
            </div>
            <div className="text-[#60656D] mb-4">
              Manage LOA & Reimbursements Effortlessly
            </div>
            <button
              onClick={handleReimbursementRequest}
              // className="relative w-full transition ease-in-out delay-75 border border-[#E3E4E5] rounded-md p-2 mb-3"
              className="flex items-center text-left w-full transition ease-in-out delay-75 hover:scale-105 border border-[#E3E4E5] rounded-md p-2 mb-3"
            >
              <div className="flex items-center text-left">
                <img
                  src={require("../../assets/reimbursement.png")}
                  alt="Personal"
                  className="w-10"
                />
                <div className="ml-2">
                  <p className="font-semibold mb-1">Reimbursement request</p>
                  <p className=" text-[#60656D]">
                    Get expenses covered fast! Choose this option to request
                    reimbursement
                  </p>
                </div>
              </div>
            </button>
            <button
              className="flex items-center text-left w-full transition ease-in-out delay-75 hover:scale-105 border border-[#E3E4E5] rounded-md p-2 mb-3"
              onClick={() =>
                handleShowAlert(
                  "/loa-reimbursement-services/consultation-loa-request"
                )
              }
            >
              <img
                src={require("../../assets/consultation.png")}
                alt="Corporate"
                className="w-10"
              />
              <div className="ml-2">
                <p className="font-semibold mb-1">Consultation LOA request</p>
                <p className="text-[#60656D]">
                  Authorize your consultation fast. Choose this for an easy
                  process.
                </p>
              </div>
            </button>
            <button
              className="flex items-center text-left w-full transition ease-in-out delay-75 hover:scale-105 border border-[#E3E4E5] rounded-md p-2"
              onClick={() =>
                handleShowAlert(
                  "/loa-reimbursement-services/medical-test-loa-request"
                )
              }
            >
              <img
                src={require("../../assets/medical.png")}
                alt="Corporate"
                className="w-10"
              />
              <div className="ml-2">
                <p className="font-semibold mb-1">Medical test LOA request</p>
                <p className="text-[#60656D]">
                  Quickly authorize your medical test. Select this option for
                  smooth processing
                </p>
              </div>
            </button>
          </div>
        </div>
      </div>
      <KycModal open={modalShown} onClose={handleCloseModal} />
      <AlertModal
        open={alertModalShown}
        path={path}
        onClose={() => setAlertModalShown(false)}
      />
    </div>
  );
};

export default LOAReimbursement;
